import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { CapturumInputComponent } from '@capturum/ui/input';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';
import { FormTooltipComponent } from '@shared/components/form-tooltip/form-tooltip.component';

@Component({
  selector: 'app-email-input',
  templateUrl: './email-input.component.html',
  imports: [CapturumInputComponent, ManageValidatorDisplayDirective, ReactiveFormsModule, FormTooltipComponent],
})
export class EmailInputComponent extends FieldType implements OnInit {
  public ngOnInit(): void {
    this.formControl.setValidators(Validators.email);
  }
}
